import { useCallback } from 'react';
import { Link } from 'react-router-dom-v5-compat';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { CUSTOM_BUTTON_COLOR, CustomButton } from 'src/components/CustomButton';
import { getCustomerPlan, planCanBeUpgraded } from 'src/data/subscription';
import { ROUTES } from 'src/routes';
import { useCurrentCustomer } from 'src/store';

import { useEvents } from './useEvents';
import { useStyles } from './useStyles';

export const ViewSubscriptionStatus = ({ className }) => {
  const styles = useStyles();
  const currentCustomer = useCurrentCustomer();
  const events = useEvents();
  const plan = getCustomerPlan(currentCustomer);
  const upgradeVisible = planCanBeUpgraded(plan);

  const handleRequestUpgrade = useCallback(() => {
    events.trackPurchaseClick();
  }, [events]);

  if (!upgradeVisible) {
    return null;
  }

  return (
    <CustomButton
      className={cx(styles.root, className)}
      onClick={handleRequestUpgrade}
      component={Link}
      to={ROUTES.UPGRADE}
      color={CUSTOM_BUTTON_COLOR.upsell}
      data-testid="viewSubscriptionStatusUpgradeButton"
    >
      Upgrade
    </CustomButton>
  );
};

ViewSubscriptionStatus.propTypes = {
  className: PropTypes.string,
};
ViewSubscriptionStatus.defaultProps = {
  className: null,
};
